import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { friendlyShortImpactTitle } from '@upright/common/utils';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';
import { useCarouselLayout } from '@upright/ui/common/upright/core/impact-lens-profile/context';
import { ImpactTitleNetFigure } from '@upright/ui/common/upright/core/impact-lens-profile/frame/impact-titles/impact-title-net-figure';
import styled, { css } from 'styled-components';

interface Props {
  impact: ImpactCategoryId;
  isSelected: boolean;
  handleImpactClick: ((impactId: ImpactCategoryId) => void) | undefined;
  isClickable?: boolean;
}

export function ImpactTitle(props: Props) {
  const layout = useCarouselLayout();
  const area = layout.impactCenterArea(props.impact);
  const transform = `translate(${area.x1}px, ${area.y1}px)`;
  const textTransform = `translate(${area.width / 2}px, ${area.height / 2}px)`;
  const isClickable = props.isClickable ?? !!props.handleImpactClick;
  return (
    <>
      <G
        style={{ transform }}
        onClick={() => {
          props.handleImpactClick?.(props.impact);
        }}
        isClickable={isClickable}
      >
        <rect
          width={area.width}
          height={area.height}
          fill="transparent"
          stroke={props.isSelected ? BouColor.BLACK : 'transparent'}
        />
        <g style={{ transform: textTransform }}>
          <TitleText isClickable={isClickable} isSelected={props.isSelected} dy="0.35em" textAnchor="middle">
            {friendlyShortImpactTitle(props.impact)}
            <ImpactTitleNetFigure impact={props.impact} />
          </TitleText>
        </g>
      </G>
    </>
  );
}

const G = styled.g<{ isClickable: boolean }>`
  ${p =>
    p.isClickable
      ? css`
          cursor: pointer;
          transition: fill 0.12s ease-in-out;
          &:hover,
          &:active {
            fill: ${BouColor.TOOL_TEXT_LIGHT_GRAY};
          }
        `
      : ''}
`;

const TitleText = styled.text<{ isClickable: boolean; isSelected: boolean }>`
  fill: ${p => (p.isSelected ? `${BouColor.TOOL_TEXT_ERROR_RED}` : `${BouColor.PLATFORM_TEXT_GRAY_DARK}`)};
`;
